<template>
	<v-row>
		<v-row justify="center" class="back">
			<ContatoApresentacao :dialog="dialogContato" @dialogClose="dialogContatoClose" />
			<div class="apresentacaoCard">
				<div align="center" class="apresentacaoConteudo">
					<v-spacer />
					<img class="apresentacaoImagem d-none d-md-flex" src="@/assets/garota-apresentacao.png" />
					<div class="apresentacaoTextos">
						<div class="apresentacaoTitulo">SIC E-commerce</div>
						<div class="apresentacaoDetalhes">
							Comece a vender online agora mesmo, com o SIC E-commerce você pode vender seus produtos
							cadastrados no SIC de forma rápida e fácil.
						</div>
						<div class="apresentacaoBotao">
							<v-btn color="#922125" class="white--text mt-2" @click="entrarEmContato"
								><strong>Entrar em contato</strong></v-btn
							>
						</div>
					</div>
					<img
						class="apresentacaoImagem d-flex d-md-none"
						src="@/assets/garota-apresentacao.png"
						height="400"
					/>
					<v-spacer />
				</div>
			</div>
			<v-col cols="12" class="pb-0">
				<v-row justify="center">
					<div class="subtituloApresentacao">Como funciona o SIC E-Commerce:</div>
				</v-row>
			</v-col>
			<v-col xs="12" sm="7" md="8" lg="8" xl="4" class="pb-0">
				<v-row justify="center">
					<template v-for="item in this.itens">
						<v-col :key="item.id" class="pt-0">
							<CardApresentacao :item="item" />
						</v-col>
					</template>
				</v-row>
			</v-col>
		</v-row>
	</v-row>
</template>

<script>
import CardApresentacao from '../components/Apresentacao/CardApresentacao.vue'
import ContatoApresentacao from '../components/Apresentacao/ContatoApresentacao.vue'
export default {
	components: { CardApresentacao, ContatoApresentacao },
	data() {
		return {
			dialogContato: false,
			itens: [
				{
					numero: '1',
					cor: 'vermelho',
					descricao: 'Você cadastra os produtos no SIC.',
					imagem: 'home-1.png',
				},
				{
					numero: '2',
					cor: 'vermelhoEscuro',
					descricao: 'Seleciona quais produtos vai enviar para o E-commerce.',
					imagem: 'home-2.png',
				},
				{
					numero: '3',
					cor: 'cinzaEscuro',
					descricao: 'O cliente acessa o link do e-commerce.',
					imagem: 'home-3.png',
				},
				{
					numero: '4',
					cor: 'vermelho',
					descricao: 'O cliente faz o pedido.',
					imagem: 'home-4.png',
				},
				{
					numero: '5',
					cor: 'vermelhoEscuro',
					descricao: 'O pedido será sincronizado com o seu servidor e abrirá uma DAV.',
					imagem: 'home-5.png',
				},
				{
					numero: '6',
					cor: 'cinzaEscuro',
					descricao: 'O cliente ainda poderá te mandar o pedido via WhatsApp.',
					imagem: 'home-6.png',
				},
			],
		}
	},
	methods: {
		entrarEmContato() {
			this.dialogContato = true
		},
		dialogContatoClose() {
			this.dialogContato = false
		},
	},
}
</script>

<style>
.content {
	align-content: flex-end;
}
.apresentacaoImagem {
	height: 400px;
}
.apresentacaoConteudo {
	display: flex;
	align-items: center;
}
.apresentacaoTitulo {
	text-align: start;
	color: var(--v-primary-base);
	font-size: 36px;
	font-weight: 900;
	width: 310px;
}
.apresentacaoDetalhes {
	text-align: start;
	width: 300px;
}
.apresentacaoCard {
	width: 100%;
	background-color: #ffffff;
	border-radius: 0 0 50px 50px;
}
.apresentacaoTextos {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
}
.back {
	margin-top: 2px;
	background-color: #464646;
}
.subtituloApresentacao {
	color: #ffffff;
	font-size: 20px;
	font-weight: 100;
	padding-bottom: 0;
}
@media only screen and (max-width: 660px) {
	.apresentacaoConteudo {
		display: inline;
	}
	.apresentacaoImagem {
		margin-top: 25px;
		height: 250px;
	}
	.apresentacaoDetalhes {
		text-align: center;
	}
	.apresentacaoTitulo {
		text-align: center;
	}
	.apresentacaoTextos {
		align-items: center;
	}
}
</style>